var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2891,
    cy: 43.2891,
    r: 43.2891,
    fill: "#FF9F1E",
    fillOpacity: 0.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.785 52.3208L46.4023 27.151C46.0887 26.5976 45.6339 26.1373 45.0843 25.8171C44.5348 25.4968 43.9101 25.3281 43.2741 25.3281C42.638 25.3281 42.0133 25.4968 41.4638 25.8171C40.9142 26.1373 40.4594 26.5976 40.1458 27.151L25.7631 52.3208C25.4461 52.8697 25.2799 53.4928 25.2813 54.1267C25.2827 54.7606 25.4516 55.3829 25.7711 55.9305C26.0905 56.4781 26.549 56.9315 27.1001 57.2447C27.6512 57.558 28.2754 57.72 28.9093 57.7143H57.6748C58.3056 57.7136 58.9252 57.547 59.4713 57.2312C60.0174 56.9153 60.4708 56.4614 60.786 55.9148C61.1011 55.3683 61.2669 54.7485 61.2668 54.1177C61.2666 53.4868 61.1005 52.8671 60.785 52.3208Z",
    stroke: "#FF9F1E",
    strokeWidth: 3.59569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2969 36.1406V43.332",
    stroke: "#FF9F1E",
    strokeWidth: 3.59569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2969 50.5234H43.315",
    stroke: "#FF9F1E",
    strokeWidth: 3.59569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.071f3c226a7964f85130fe10e6a0418c.svg";
export { ForwardRef as ReactComponent };